/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Shopping_CheckedInputs */

const en_shopping_checked = /** @type {(inputs: Shopping_CheckedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Checked off (${i?.count})`)
};

const de_shopping_checked = /** @type {(inputs: Shopping_CheckedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abgehakt (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Checked off ({count})" |
*
* @param {Shopping_CheckedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_checked = /** @type {((inputs: Shopping_CheckedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_CheckedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_checked(inputs)
	return en_shopping_checked(inputs)
});